import { TaggedDataSetReference } from 'libs/end-to-end/src/types/databases/data-sets/data-set-reference';

export const localCompositeDataSetCommand = ({
  taggedDataSetReferences,
  uiEnvironmentName,
  uiSandboxName,
  organizationId,
  databaseId,
  compositeDataSetId,
}: {
  taggedDataSetReferences: TaggedDataSetReference[];
  uiEnvironmentName: string;
  uiSandboxName: string;
  organizationId: string;
  databaseId: string;
  compositeDataSetId: string;
}): string => {
  const dataSetsCommandString = taggedDataSetReferences
    .map(
      (ds) =>
        `${ds.automationTag}/${ds.dataSetReference.dataSetId}/${ds.dataSetReference.dataSetVersion}`,
    )
    .join(' ');
  return `S2_ENVIRONMENT_NAME="${uiEnvironmentName}" S2_SANDBOX_NAME="${uiSandboxName}" AWS_PROFILE="${uiEnvironmentName}" pnpm tool local-composite-data-set --org-id ${organizationId} --db-id ${databaseId} --ds-id ${compositeDataSetId} ${dataSetsCommandString}`;
};
